import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSync } from '@fortawesome/pro-light-svg-icons'

import { Button, Tools } from '@domain-group/suit-theme'

import useClient from '@hooks/useClient'

import { confirmAction } from '@functions/entity'

interface ClientToolsProps {
  clientPayload: ReturnType<typeof useClient>,
}

const ClientTools = (props: ClientToolsProps) => {
  const {
    clientPayload: {
      callbacks: {
        syncClient: syncClientFn,
      },
      loading,
    },
  } = props

  const syncClientPayload = {
    callbacks: {
      actionFn: syncClientFn,
    },
    strings: {
      actionString: 'synchronize',
      entityName: 'organization',
    },
  }

  return (
    <Tools>
      {!loading && 
        <Button
          buttonStyle="secondaryUtility"
          icon={<FontAwesomeIcon icon={faSync} />}
          marginBottom="medium"
          onClick={() => confirmAction(syncClientPayload)}
          size="medium"
        >
          Synchronize
        </Button>
      }
    </Tools>
  )
}

export default ClientTools
